import {Moment } from 'moment';
import {ItemOrderHistoryLine} from "./item-order-history-line";

export abstract class ItemOrderHistoryBase<T extends { visible: boolean}> {
    protected constructor(
        public readonly id: string,
        public readonly orderId: number,
        public readonly innerOrderId: number,
        public readonly date: string,
        public readonly planArriveDate: string,
        public readonly documentNo: number,
        public readonly order: string,
        public readonly orderType: string,
        public readonly distOrder: number,
        public readonly sentOrder: number,
        public readonly sentOrderStyle: number,
        public readonly status: number,
        public readonly statusDesc: string,
        public readonly statusDescStyle: number,
        public readonly fulfillment: number,
        public readonly fulfillmentDesc: string,
        public readonly fulfillmentDescStyle: number,
        public readonly arrivalDate: string,
        public readonly arrivedQuantity: number,
        public readonly supplierCode: string,
        public readonly supplierName: string,
        public readonly buffer: string,
        public readonly safetyStock: string,
        public readonly balance: number,
        public readonly inTransit: number,
        public readonly need: number,
        public readonly hasData: string,
        public readonly hasMoq: string,
        public readonly hasMoa: string,
        public readonly extraAttribute: string,
        public readonly purchasePrice: number,
        public readonly newMover: number,
        public readonly newMoverDesc: string,
        isCwh: boolean,
        public readonly crossDock: T) {
        this.isCwhOrder = isCwh;
        this.visible = true;
        if (this.crossDock){
            this.crossDock.visible = false;
        }
        this.purchasePrice = Math.round((this.purchasePrice + Number.EPSILON) * 100) / 100
    }

    readonly isCwhOrder: boolean;

    visible: boolean;

    hiddenByFilter: boolean;

    // get id(): string {
    //     return `${this.orderId}`;
    // }
}





// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/item-order-history/item-order-history-base.ts